import React, { useCallback, useContext, useEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';
import { PersonCircle } from 'react-bootstrap-icons';

import { Feedback } from '../../Interface/ValidatorFeedback';
import FeedbackForm from '../General/FeedbackForm';
import { modalRequested } from '../../Store/Modal/action';
import { postValidatorFeedback } from '../../Service/FeedbackService';
import ResultContext from '../../Context/ResultContext';
import { Result } from '../../Interface/Response/Validator/Result';

import { useDispatch } from 'react-redux';
import useGetModal from '../../Hook/UseGetModal';

interface Props {
    caseId: string;
}

interface State {
    error: boolean;
    showModal: boolean;
    submitted: boolean;
}

const INITIAL_STATE = { error: false, showModal: false, submitted: false };

const FeedbackButton: React.FC<Props> = ({ caseId }: Props) => {
    const dispatch = useDispatch();
    const result = useContext<Result | null>(ResultContext);
    const { content } = useGetModal();
    const [{ error, showModal, submitted }, setState] = useState<State>(INITIAL_STATE);

    const submitFeedbackForm = useCallback(
        (feedback: Feedback) => {
            postValidatorFeedback({ ...feedback, caseId }).then(
                () => setState({ error: false, showModal: true, submitted: true }),
                () => setState({ error: true, showModal: true, submitted: false }),
            );
        },
        [caseId],
    );

    useEffect(() => {
        if (null === content) setState(INITIAL_STATE);
    }, [content]);

    useEffect((): void => {
        if (showModal) {
            const button = !submitted ? (
                <Button variant="primary" type="submit" form="feedback-form">
                    Verzenden
                </Button>
            ) : null;
            const feedbackForm = (
                <FeedbackForm error={error} submitFeedbackForm={submitFeedbackForm} submitted={submitted} />
            );
            dispatch(modalRequested(button, feedbackForm, 'Feedback validator'));
        }
    }, [error, showModal, submitted, dispatch, submitFeedbackForm]);

    if (!result) {
        return null;
    }

    return (
        <div className="feedback">
            <button onClick={() => setState({ error: false, showModal: true, submitted: false })}>
                <PersonCircle />
                Feedback?
            </button>
        </div>
    );
};

export default FeedbackButton;
